import { RootEpic } from "../../../store/epics";
import { isActionOf} from 'typesafe-actions';
import {
    from,
      filter,
      switchMap,
      withLatestFrom,
      of,
} from 'rxjs';
import { requestResetPassword, verifyOtp } from "./actions";
import { pushRoute, putMessage } from "../../app/store/actions";
import { ROUTES } from "../../../history";
import { selectEmail } from "./selectors";



const requestResetPasswordEpic: RootEpic = (action$, state$,{api}) => 
    action$.pipe(
        filter(isActionOf(requestResetPassword.request)),
        switchMap(({payload}) => {
          return from(api.requestResetPassword({}, {Authorization: ''}, {Email: payload}))
            .pipe(
                switchMap(res => {
                    const ret = [];
                    if(res.code === 200 || res.code === 201) {
                        ret.push(requestResetPassword.success(res.data!.data!))
                    }
                   else  ret.push(requestResetPassword.failure(res));
                   return ret;
                })
            )
        })
    );


const verifyOtpEpic: RootEpic = (action$, state$, {api}) =>

action$.pipe(
    filter(isActionOf(verifyOtp.request)),
    withLatestFrom(state$),
    switchMap(([{payload: {otp , password}}, state]) => {
        const email = selectEmail(state) as string;

        return from(api.verifyOtp({}, {Authorization: ''},{
            Email: email,
           token: otp,
           password
        })).pipe(
            switchMap(res => {
                if(res.code === 200 || res.code === 201) {
                    if(res.data!.data.done) {
                    return of(verifyOtp.success({
                        verified: true,
                        validOtp: otp
                    }))}
                    else {
                        return [
                            verifyOtp.failure('error'),
                            putMessage({
                                type:'error',
                                message: 'Invalid Otp Failed to reset'
                            })
                        ]
                    }
                }
               return of(verifyOtp.failure(res))
            })
        )
    })
 )


 const passwordResetSuccess: RootEpic  = action$ => 
    action$.pipe(
        filter(isActionOf(verifyOtp.success)), 
        switchMap(() => {
            return [
                putMessage({type: 'success', message: 'Password reset success'}), 
                pushRoute({route:  ROUTES.CONTRACTOR_AUTH})
            ]
        })
    )
 const UserActivitiesEpics = [
    requestResetPasswordEpic,
    verifyOtpEpic,
    passwordResetSuccess,
];

export default UserActivitiesEpics;